import React from "react";
import { MARQUEE_WORDS } from "../mock";

export default function Marquee() {
  const row = [...MARQUEE_WORDS, ...MARQUEE_WORDS];
  return (
    <div className="bg-[#D5521B] text-[#F3EAD7] py-4 overflow-hidden select-none">
      <div className="marquee-track">
        {row.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-xl md:text-2xl font-semibold px-5 whitespace-nowrap">
              {w}
            </span>
            <span className="text-[#F0C766] text-lg">·</span>
          </span>
        ))}
      </div>
    </div>
  );
}
